import { render, staticRenderFns } from "./CampaignBalance.vue?vue&type=template&id=b296e520&scoped=true&"
import script from "./CampaignBalance.vue?vue&type=script&lang=js&"
export * from "./CampaignBalance.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBalance.vue?vue&type=style&index=0&id=b296e520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296e520",
  null
  
)

export default component.exports